/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, March 30th 2022, 6:57:03 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { intersection, isEmpty } from "lodash";
import { PaymentMethod } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import {
  APIMany2ManyTransferListFormInput,
  ConcreteAPIMany2ManyTransferListFormInputProps,
  ConcreteAPIMany2ManyInputProps,
  APIMany2ManyCheckBoxFormInput,
  Image,
} from "ui-widgets";

type PropsWithCurrencies = {
  currencies?: string[];
};

export const PaymentMethodsMany2ManyTransferPicker = <TPrimaryObject,>(
  props: ConcreteAPIMany2ManyTransferListFormInputProps<TPrimaryObject, PaymentMethod> & PropsWithCurrencies
) => (
  <APIMany2ManyTransferListFormInput<TPrimaryObject, PaymentMethod>
    apiServicePath={APISERVICEPATHS.paymentMethods}
    itemIdProperty="id"
    getOptionComponent={(option) => (
      <ListItemText primary={<Image src={option.image_url} width="30px" height="30px" />} secondary={option.name} />
    )}
    {...props}
  />
);

interface PaymentMethodsMany2ManyCheckboxesPickerProps<TPrimaryObject>
  extends ConcreteAPIMany2ManyInputProps<TPrimaryObject, PaymentMethod>,
    PropsWithCurrencies {
  PaymentProviderCredentialsButtonComponent: React.ComponentType<{ paymentProvider: PaymentMethod }>;
}

export const PaymentMethodsMany2ManyCheckboxesPicker = <TPrimaryObject,>({
  PaymentProviderCredentialsButtonComponent,
  ...props
}: PaymentMethodsMany2ManyCheckboxesPickerProps<TPrimaryObject>) => (
  <APIMany2ManyCheckBoxFormInput<TPrimaryObject, PaymentMethod>
    apiServicePath={APISERVICEPATHS.paymentMethods}
    getFilteredItems={
      props.currencies?.length > 0 &&
      ((items) =>
        items.filter((item) => {
          return (
            item.supported_currencies.length === 0 ||
            !isEmpty(intersection(props.currencies, item.supported_currencies))
          );
        }))
    }
    itemIdProperty="id"
    getOptionComponent={(option, { isSelected }) => (
      <ListItemText
        primary={
          <Stack direction="row" spacing={8}>
            <Image src={option.image_url} width="30px" height="30px" />
            {isSelected && (
              <div onClick={(e) => e.stopPropagation()}>
                <PaymentProviderCredentialsButtonComponent paymentProvider={option} />
              </div>
            )}
          </Stack>
        }
        secondary={option.name}
      />
    )}
    {...props}
  />
);
